import apiService from '../apiService';

const ITEM_URL = 'setup/items';
const itemService = {

    async createItem(payload) {
        try {
            const response = await apiService.post(`/${ITEM_URL}`, payload);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async getAllItem(params = {}) {
        try {
            const queryParams = new URLSearchParams(params).toString();
            const response = await apiService.get(`/${ITEM_URL}${queryParams ? `?${queryParams}` : ''}`);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async getSingleItem(id) {
        try {
            const response = await apiService.get(`/${ITEM_URL}/${id}`);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async updateItem(payload, id) {
        try {
            const response = await apiService.put(`/${ITEM_URL}/${id}`, payload);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async deleteItem(id) {
        try {
            const response = await apiService.delete(`/${ITEM_URL}/${id}`);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },


};

export default itemService;